export const WSB_MERCHANT_SOURCE = 'onecom_wsb';

/**
 * Sparse fields for boot/current merchant via merchantV2.find and
 * merchantV2.findAll (first-merchant fallback). Keep both call sites on this.
 */
export const CURRENT_MERCHANT_V2_FIELDS = {
  merchants: [
    'feature_toggles',
    'name',
    'organization',
    'created_at',
    'currency',
    'source',
    'ui_visibility',
    'category',
    'pixel_id',
    'slug',
    'phone',
    'time_zone',
    'address',
    'suspended',
    'suspension_reason',
  ],
  organizations: [
    'id',
    'trial_ends_on',
    'trial_days_left',
    'self_sign_up',
    'test',
    'package_code',
    'whitelabel_slug',
  ],
};

export const CURRENT_MERCHANT_V2_INCLUDE = ['organization'] as const;

export const GRAVITY_ACTIVATION_CLASS = 'gv-activated gv-h-full';

export const GRAVITY_DESIGN_APPS = [
  'ai-receptionist',
  'calendar-v2-gsd',
  'services-v2',
  'settings-v2',
  'settings-v3',
  'appointment-v3',
  'appointment-v4',
  'reminders-v2',
];

// Gravity version is pinned in `webpack.data.js`; brand choice lives in
// `../styles/gravity-brand.ts`.
